import React, { useContext } from 'react';

import ClickableCard from '../../utils/ClickableCard';
import { ActivityContext } from '../../../contexts/Activity';
import { ActivitySource } from '../../../types/Activity';

type Props = {
  allowEditOrderReason: boolean;
  allowCancelOrderReason: boolean;
  onReasonChoose(reason: string): void;
  onCancel(): void;
};

export default function ReasonChoicePage(props: Props) {
  const activityContext = useContext(ActivityContext);
  const orderUpdateReasonPage =
    activityContext.source === ActivitySource.fareharbor
      ? 'needFareharborOrderUpdate'
      : 'needOrderUpdate';

  const editOrderReasonHelpText = props.allowEditOrderReason
    ? 'For example: date, time, number of participants, or option changes.'
    : 'Not available for canceled orders.';

  const cancelOrderReasonHelpText = props.allowCancelOrderReason
    ? 'Customer or vendor wants to cancel the booking entirely'
    : 'This order is already canceled.';

  return (
    <>
      <header>
        <h4>What is refund request related to?</h4>
      </header>
      <main>
        <div className='request-refund-modal__page-content'>
          <p>
            Please choose the reason for refund request so we can guide you to
            the right process.
          </p>
          <ClickableCard
            caption='Order details need to be changed'
            helpText={editOrderReasonHelpText}
            variant='primary'
            onClick={() => props.onReasonChoose(orderUpdateReasonPage)}
            disabled={!props.allowEditOrderReason}
          />
          <ClickableCard
            caption='Order need to be canceled'
            helpText={cancelOrderReasonHelpText}
            variant='primary'
            onClick={() => props.onReasonChoose('needOrderCancel')}
            disabled={!props.allowCancelOrderReason}
          />
          <ClickableCard
            caption='Other reason'
            helpText='Request a refund for reasons not related to order changes.'
            variant='secondary'
            onClick={() => props.onReasonChoose('requestRefund')}
          />
        </div>
      </main>
      <footer className='modal__footer'>
        <menu className='modal__actions modal__actions--center'>
          <button
            key='cancel'
            className='btn btn-secondary btn--wide'
            type='button'
            onClick={props.onCancel}
          >
            Cancel
          </button>
        </menu>
      </footer>
    </>
  );
}
